import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { Translate as TranslateIcon } from '../icons';
import { languages } from "./languages";

const SelectLanguage = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState('es');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (langCode) => {
    setSelected(langCode);
    // Aquí deberías agregar la lógica real para cambiar el idioma global
    handleClose();
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <TranslateIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={selected === lang.code}
            onClick={() => handleSelect(lang.code)}
          >
            <span style={{ marginRight: 10, fontSize: 22 }}>{lang.flag}</span>
            {lang.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SelectLanguage;
